import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {useSelector} from "react-redux";
import {TripModel} from "../firebase/index.js";


export const inMemoryTripSliceName = "inMemoryTrip";

const inMemoryTripSlice = createSlice({
	  name: inMemoryTripSliceName,
	  initialState: {trip: null},
	  reducers: {
			 setTrip: (state, action: PayloadAction<TripModel>) => {
					state.trip = action.payload;
			 },
			 clearTrip: (state) => {
					state.trip = null;
			 }
	  }
});

export const {setTrip, clearTrip} = inMemoryTripSlice.actions;

const inMemoryTripReducer = inMemoryTripSlice.reducer;
export default inMemoryTripReducer;


export function useInMemoryTrip(): TripModel {
	  return useSelector((state) => state[inMemoryTripSliceName].trip);
}